@let showBoostLabel = message.is_me && message.boosted;
@let canShowContextNav = breakpoint2Service.supportsHover$ | async;

<sb-message-wrapper
  class="wrapper"
  [class.wrapper--with-boost-label]="showBoostLabel"
  [messageType]="message.is_me ? 'sent' : 'received'"
  [photoUrl]="photoUrl!"
>
  <div class="display-flex align-items-center gap-2" [class.flex-direction-row-reverse]="message.is_me">
    <div class="position-relative">
      @if (showBoostLabel) {
        <div
          class="boost-label color-yellow bg-blue border-radius-circle center-flex position-absolute"
          [placement]="'bottom'"
          [sbTooltip]="'You’ve already boosted this message.'"
        >
          <sb-icon [name]="'flash'" [size]="'8'" />
        </div>
      }

      @switch (message.type) {
        @case ('text') {
          <div
            #textContent
            class="text-content t-7@r fs-exclude"
            [class.text-content--boosted]="message.boosted"
            [class.text-content--focused]="textContentFocused()"
            [innerHTML]="message.body"
            [ngClass]="message.is_me ? 'text-content--sent' : 'text-content--received'"
            (press)="$event.preventDefault(); onTextContentPress(textContent, contextNavContentTemplate)"
          ></div>
        }
        @case ('photo') {
          <sb-message-photo [conversation]="conversation" [message]="message" />
        }
        @case ('voice') {
          <sb-voice-message [conversation]="conversation" [message]="message" />
        }
      }
    </div>

    @if (boostable || (message.boosted && !message.is_me) || (canShowContextNav && message.type === 'text')) {
      <!-- Largest possible width must be set to prevent layout shift on message changes -->
      <!-- This has to be adjusted when actions inside are modified -->
      @let spacingWidth = 8;
      @let boostToggleWidth = 79;
      <div
        class="actions flex-shrink-0 display-flex align-items-center gap-2"
        [class.flex-direction-row-reverse]="message.is_me"
        [style.width.px]="canShowContextNav ? boostToggleWidth + spacingWidth : boostToggleWidth"
      >
        @if (boostable) {
          <sb-field-boost [disabled]="true" [ngModel]="message.boostInProgress" (click)="onBoostClick()" />
        }

        @if (message.boosted && !message.is_me) {
          <sb-icon
            class="color-iron"
            tabindex="-1"
            [name]="'help-circle'"
            [sbTooltip]="'This message was boosted to get your attention.'"
            [size]="'6'"
          />
        }

        @if (canShowContextNav && message.type === 'text') {
          <sb-icon
            #contextNavAction
            class="context-nav-action color-void pointer-events cursor-pointer"
            tabindex="-1"
            [class.context-nav-action--focused]="textContentFocused()"
            [name]="'menu-dots'"
            [size]="'6'"
            (click)="
              openContextMenu(
                contextNavAction.elementRef.nativeElement,
                contextNavContentTemplate,
                message.is_me ? 'bottom_right' : 'bottom_left'
              )
            "
          />
        }
      </div>
    }

    <ng-template #contextNavContentTemplate>
      @if (message.type === 'text') {
        <sb-context-menu-content [layout]="('tablet' | breakpointAbove) ? 'compact' : 'bottom-attached'">
          <li><a (click)="copyToClipboard(message.body)">Copy</a></li>
        </sb-context-menu-content>
      }
    </ng-template>
  </div>
</sb-message-wrapper>
